var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('Headline'),_c('HowItWorks'),_c('GradientArrow',{attrs:{"separator-title":"Kiemelt ajánlatok"}}),_c('OfferList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }